import { NgModule } from "@angular/core";
import { LicensePanelItemComponent } from "./license-panel-item.component";
import { CommonModule } from "@angular/common";
import { SharedModule } from "src/app/shared/shared.module";
import { TranslateModule } from "@ngx-translate/core";
import { NgxMaskModule } from "ngx-mask";

@NgModule({
  imports: [CommonModule, SharedModule, TranslateModule, NgxMaskModule.forRoot()],
  exports: [LicensePanelItemComponent],
  declarations: [LicensePanelItemComponent],
})
export class LicensePanelItemModule {}
